import { Component, OnInit, Input, Output, EventEmitter,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  TransferHistList,TransferHistory
} from '../../work-order/work-order-models';

import { FPMessage, Severities, PageKey, RoleAccess,PagerList  } from '../../shared/shared.model';
 import { WoService } from '../../work-order/work-order.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { PopupInit } from '../../shared/init-popup';
import { DatePipe } from '@angular/common';
import { Message, ConfirmationService,Paginator } from 'primeng/primeng';
import { BaseComponent } from '../../shared/base.component';
import { CapitalizeFirstPipe } from '../../shared/pipes/custom-pipes.pipe';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { LoaderService } from '../loader.service';


@Component({
  // moduleId: module.id,
  selector: 'assettransfer-history-popup',
  templateUrl: 'assettransfer-history-popup.component.html'
})
export class AssetTransferHistoryPopupComponent extends BaseComponent implements OnInit {
  transferHist: TransferHistory[];
  transferHistList:TransferHistList;
   @Input() historyModelId: number;
   @Input() historyBrandId: number;
   @Input() historyBrand: number;
   @Input() historyModel: number;
   @Input() historySerialNo: number;
   @Output() done = new EventEmitter();
  stacked: boolean;
  public rows: number;
  public page: number;
  public order: string;
  public sortby: string;
  public rowsperOptions: any;
   public getRows: number;
   TotalCount: number;
   pagerList: PagerList;
   @ViewChild('paginator') paginator: Paginator;
   @ViewChild('dt') dt: any;
  constructor(protected translateService: TranslateService, private loaderservice: LoaderService, protected _woService: WoService,
    private formBuilder: FormBuilder, private route: ActivatedRoute,
   private datePipe: DatePipe,protected sharedService: SharedService) {
   super(sharedService, translateService)
   this.rowsperOptions = this.sharedService.getRowsPerOptions();
   this.getRows = this.sharedService.getRows();
}
ngOnInit() {
  if (!this.pagerList) {
    this.pagerList = new PagerList();
  }
  if (!this.transferHistList) {
    this.transferHistList = new TransferHistList();
  }
  
   if(this.historyBrandId)
   {
    this.getHistorylist();
   }
  
}
getHistorylist() {
  
  this.loaderservice.show();
  this.rowsperOptions = this.sharedService.getRowsPerOptions();
  this.getRows = this.sharedService.getRows();
  this.rows = this.getRows;
  this.page = 0;
  this.pagerList.CompanyId = super.globalInfo().CompanyId;
  this.pagerList.SortBy = "Asc";
  this.pagerList.OrderBy = "BrandName";
  this.pagerList.StartRecord = 0;
  this.pagerList.EndRecord = this.rows;
  this.pagerList.SearchBy = '';
  this._woService.getTransferHistory(this.historyBrandId,this.historyModelId, this.pagerList)
    .subscribe(resp => {
      
      this.transferHistList.TotalRecord = resp.TotalRecord;
      this.transferHistList.TransferHistory= resp.TransferHistory;
    //   if(this.transferHistList.TransferHistory)
    //   {
    //  // this.paginator.first = 0;
    //   this.paginator.rows = this.getRows;
    //   }
      this.loaderservice.hide();
    });
 
}
paginate(event) {
  
  this.loaderservice.show();
  this.pagerList.CompanyId = super.globalInfo().CompanyId;
  this.pagerList.SortBy = this.sortby;
  this.pagerList.OrderBy = this.order;
  this.pagerList.StartRecord = event.page;
  this.page = event.page;
  this.pagerList.EndRecord = event.rows;
  this.rows = event.rows;
 this.pagerList.SearchBy = '';
  this._woService.getTransferHistory(this.historyBrandId,this.historyModelId, this.pagerList)
    .subscribe(resp => {
      
      this.transferHistList.TotalRecord = resp.TotalRecord;
      this.transferHistList.TransferHistory= resp.TransferHistory;
      // if(this.transferHistList.TransferHistory)
      // {
      // this.paginator.first = 0;
     
      // }
      this.loaderservice.hide();
    });
}
sort(event) {
  
  this.loaderservice.show();
  this.pagerList.CompanyId = super.globalInfo().CompanyId;
  if (event.order == 1)
    this.sortby = "Asc";
  else
    this.sortby = "Desc";
  this.pagerList.SortBy = this.sortby;
  this.pagerList.OrderBy = event.field;
  this.order = event.field;
  this.pagerList.StartRecord = this.page;
  this.pagerList.EndRecord = this.rows;
 this.pagerList.SearchBy = '' ;
 this._woService.getTransferHistory(this.historyBrandId,this.historyModelId, this.pagerList)
 .subscribe(resp => {
   
   this.transferHistList.TotalRecord = resp.TotalRecord;
   this.transferHistList.TransferHistory= resp.TransferHistory;

   this.transferHistList.TransferHistory.map(x=>
    {
        x.LastTransferreddate = x.LastTransferreddate ? this.datePipe.transform(x.LastTransferreddate, 'short')  : null;
       
       }
    );
  //  if(this.transferHistList.TransferHistory)
  //  {
  //  this.paginator.first = 0;
 
  //  }
   this.loaderservice.hide();
 });
}
 closePopup() { 
   
    this.done.emit(true);
  }

}